import { BuyerLanding } from "@/components/BuyerLanding";

export default function PartsManager() {
  return (
    <BuyerLanding
      testId="parts-manager-page"
      path="/for/parts-manager"
      seoTitle="Parts Department SOPs, Forms & Toolkit | Centennial"
      seoDescription="Control inventory, access and loss with documented processes, manager procedures and forms that lock down your counter, room and cash."
      eyebrow="For Parts Managers"
      headline="Run a parts department that controls inventory, access, and loss."
      subhead="Shrinkage, mystery counts, and open access cost you every month. Get the documented processes, manager procedures, and forms that lock down your counter, your room, and your cash."
      toolkitTitle="Your Parts toolkit"
      pains={[
        "Inventory counts that never seem to match the system",
        "Open access to the parts room with no accountability",
        "Cash and cores handled differently by every counterperson",
        "No paper trail when parts or keys go missing",
      ]}
      packs={[
        { id: "pack_security", name: "Key & Facility Security Pack", desc: "Lock down the parts room and key control with documented access, authorization, and accountability." },
        { id: "pack_osha", name: "OSHA Safety Inspection Pack", desc: "Keep the warehouse inspection-ready with hazard reporting, evacuation, and safety checklists on file." },
      ]}
      browseLink={{ label: "Browse all 36 Parts forms", to: "/forms?dept=Parts" }}
    />
  );
}
